<template>
  <div class='PrefNave'>
    <div
    v-for="(l, key) in Empresa.modelo === 'Modelo 03' ? linksModel03 : links"
    :key="key"
    :class="{ linkActive: l.to === $route.path, link: key !== 0, linkStart: true }"
    @click="$router.push(l.to)"
    >
      {{ l.name }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PrefNave',
  data () {
    return {
      links: [
        {
          name: 'Geral',
          to: '/painel/preference'
        },
        {
          name: 'Navegação',
          to: '/painel/preference/nave'
        },
        {
          name: 'Produtos',
          to: '/painel/preference/prod'
        }
      ],
      linksModel03: [
        {
          name: 'Geral',
          to: '/painel/preference'
        },
        {
          name: 'Temas',
          to: '/painel/preference/theme'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['Empresa'])
  }
}
</script>

<style scoped>
.PrefNave {
  display: flex;
  justify-content: start;
  padding: 1%;
}

.PrefNave div {
  cursor: pointer;
}

.linkStart {
  color: #000000;
  padding: 1%;
}

.link {
  color: #000000;
  padding: 1%;
}

.linkActive {
  color: #FFFFFF;
  font-weight: bold;
  padding: 1%;
  background-color: #000000;
  border-radius: 5px;
}
</style>
